import type { MemberRow, MemberSubsetOp } from 'src/components/star-grid/utils/subset-editor/memberSubset';

/** The Keep family minus plain `Keep`, which the split button's main action already performs. */
export const KEEP_MENU_OPS: readonly MemberSubsetOp[] = ['keepChildren', 'keepDescendants', 'keepLeaves', 'leavesOnly'];

export const EXPAND_ALL_ID = 'expandAll';
export const COLLAPSE_ALL_ID = 'collapseAll';

// Shared so flat rows keep one identity in tree mode and never invalidate `gridRows`.
export const NO_ROWS: MemberRow[] = [];

// A real option rather than a placeholder, so the bare hierarchy can be chosen again.
export const SUBSET_VIEW_NONE = '---';

// A display mode, not an attribute name: underscored so it cannot collide with a real alias.
export const SYSTEM_NAME_ALIAS = '__system_name__';
export const SYSTEM_NAME_LABEL = 'System Name';
